<template>
	<div class="form-container">
		<h2 class="form-title">비밀번호가 변경되었습니다.</h2>

		<p class="form-desc">변경된 비밀번호로 로그인해주세요.</p>

		<div class="form-button">
			<Btn
				@click="$router.push({ name: 'login' })"
				type="button"
				color="primary"
				x-large
				block
				>로그인</Btn
			>
		</div>
	</div>
</template>

<script>
import Btn from '@/components/common/Btn';

export default {
	components: {
		Btn,
	},
};
</script>
